
import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const ReportHeader: React.FC = () => {
  return (
    <header className="bg-blue-dark text-white py-4 px-6 sticky top-0 z-10 shadow-md">
      <div className="max-w-6xl mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center text-white hover:opacity-90 transition-opacity">
          <ArrowLeft size={20} className="mr-2" />
          <span>Voltar</span>
        </Link>
        {/* Removed download button */}
      </div>
    </header>
  );
};

export default ReportHeader;
